// extracted by mini-css-extract-plugin
module.exports = {"scroll":"_2TC-wBEQ","container":"_1sNRpZlq"};